import { Component } from '@angular/core';

@Component({
  selector: 'edge-soccer-content',
  templateUrl: './soccer-content.component.html',
  styleUrls: ['./soccer-content.component.scss']
})
export class SoccerContentComponent {
  features = [
    {
      image: 'soccer-screenshot-1.jpg',
      title: 'Draw and Edit Your Activities',
      description: `
        Draw player and ball movement, add cones, pop-up goals, or flags,
        start with the ball at a player's feet or draw a set piece play.`
    },
    {
      image: 'soccer-screenshot-2.jpg',
      title: 'See Your Plays in Real-Time 3D',
      description: `
        See Soccer action in 2D or in 3D virtual environments with accurate
        animations, timing, and ball-handling. View from any camera angle, or
        player perspective to see it as they do on the field. View in real time,
        speed, and 2x speed.`
    },
    {
      image: 'soccer-screenshot-3.jpg',
      title: 'Whiteboard',
      description: `
        Telestrate on a pre-populated whiteboard mode for instantly moving
        players around to discuss tactics on the sideline or in the locker room.`
    }
  ];

  additionalFeatures = [
    {
      title: 'Precision Player Movements',
      description: `
        Fine-tune player movements such as where they receive the ball, and
        customize ball movements by adding curve, and more, in order to
        illustrate plays accurately.`
    },
    {
      title: 'Create Custom Presentations',
      description: `
        Set up Coaching Points presentations for players to review formations,
        plays, concepts, and activities on their own with notes from the coach.`
    },
    {
      title: 'Customize Uniforms',
      description: `
        Customize uniforms to match team colors, style, and numbers for your
        team and upcoming opponents, including keeper uniforms.`
    }
  ];
}
